module.exports = __webpack_public_path__ + "static/media/9.5c3c8282.jpg";